import React from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { formatNumber } from '../../../Utils'
import { withTranslation } from 'react-i18next';

const LeatherItem = ({
    napaPrice,
    napaSelected,
    velourPrice,
    velourSelected,
    t
}) => (
    <ListGroup flush className="shopping-item-section">
        <ListGroupItem className="item-main-header">
            <strong>{t('cart.sections.laundry')}</strong>
        </ListGroupItem>
        {
            napaSelected &&
            <ListGroupItem className="item-button" active={napaSelected}>
                <div className="d-flex item-header-font">
                    <div className="item-header">{t('cart.options.napa')}</div>
                    <div className="small-price">
                        {formatNumber(napaPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
        {
            velourSelected &&
            <ListGroupItem className="item-button" active={velourSelected}>
                <div className="d-flex item-header-font">
                    <div className="item-header">{t('cart.options.velour')}</div>
                    <div className="small-price">
                        {formatNumber(velourPrice)}
                    </div>
                </div>
            </ListGroupItem>
        }
    </ListGroup>
)

export default withTranslation()(LeatherItem)